// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { classNames } from '@shared/ui-kit/utils';
import { type ComponentProps, type FC } from 'react';

export type LabelProps =
  | (ComponentProps<'label'> & {
      component?: 'label';
      required?: boolean;
      error?: boolean;
    })
  | (ComponentProps<'legend'> & {
      component?: 'legend';
      required?: boolean;
      error?: boolean;
    });

export const Label: FC<LabelProps> = ({
  className,
  ref,
  children,
  required,
  component: Component = 'label',
  error,
  ...props
}) => {
  return (
    <Component
      className={classNames(
        'text-md font-medium leading-none text-border-dark transition-colors peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
        className,
        error && 'text-negative',
      )}
      ref={ref}
      aria-required={required}
      {...(props as any)}
    >
      {children}
      {required && <span className="text-red-500">*</span>}
    </Component>
  );
};
